import React, { FC } from 'react';
import { NavCustomerButton } from './customers/NavCustomerButton';
import { NavFeaturesButton } from './features/NavFeaturesButton';
import { NavLoginButton } from './login/NavLoginButton';
import { NavPublicPricing } from './pricing/NavPublicPricing';
import { NavSignupButton } from './signup/NavSignupButton';
import { Nav } from './components/Nav';
import { NavDocumentAnalyzerLink } from './document-analyzer/NavDocumentAnalyzerLink';

export const NavPublic: FC = () => {
  return (
    <Nav dataTestId="nav-public">
      <NavDocumentAnalyzerLink />
      <NavFeaturesButton />
      <NavCustomerButton />
      <NavPublicPricing />
      <NavLoginButton />
      <NavSignupButton />
    </Nav>
  );
};
